// extracted by mini-css-extract-plugin
export var footer = "_ih-0";
export var inherit = "_ih-1";
export var input = "_ih-2";
export var modalContent = "_ih-3";
export var quillEditor = "_ih-4";
export var subtitle = "_ih-5";